export default {
  message: {
    en: 'Subscription paused, due to a wrong shipping address',
  },
  button: {
    en: 'Update your shipping address',
  },
}
